<button [disabled]="!actions()?.length && !isDeletable()" mat-icon-button color="accent" [matMenuTriggerFor]="actionMenu">
	<mat-icon class="ellipsisIcon" fontIcon="fa-ellipsis-v" fontSet="far" />
</button>
<mat-menu #actionMenu class="actionMenuOverlay">
	@for (action of actions(); track $index) {
		<!--HAS TO CHECK AGAINST 'TRUE' EXPLICITLY - COULD BE UNDEFINED-->
		@if (action.condition !== false) {
			@if (action.permission) {
				<sim-button
					[icon]="{fontIcon: action.fontIcon, fontSet: 'far'}"
					[class.gap]="!$last"
					(onClick)="action.click()"
					[label]="action.labelKey"
					[disabled]="action.disabled ?? false"
					[hasDataPermission]="action.permission.hasDataPermission"
					[permissionObj]="action.permission.permissionObj"
					variant="basic"
				/>
			} @else {
				<sim-button
					[icon]="{fontIcon: action.fontIcon, fontSet: 'far'}"
					[class.gap]="!$last"
					(onClick)="action.click()"
					[label]="action.labelKey"
					[disabled]="action.disabled ?? false"
					variant="basic"
				/>
			}
		}
	}
	@if (isDeletable()) {
		@if (actions()?.length) {
			<mat-divider />
		}
		<sim-button
			[icon]="{fontIcon: 'fa-trash-alt', fontSet: 'far'}"
			[color]="'warn'"
			(onClick)="onDelete.emit()"
			[label]="T.BUTTON_DELETE"
			variant="basic"
		/>
	}
</mat-menu>
